import type { FC } from 'react';

import Template from '../Template';
import { listDesktop, listMobile } from './content';

const Yandex: FC = () => {
    return <Template listDesktop={listDesktop} listMobile={listMobile} />;
};

export default Yandex;
